module.exports = __webpack_public_path__ + "static/flowers-bg-9f063433cd178860f77245503dab4a23.svg";